module.exports = __webpack_public_path__ + "static/media/flag.5f802b99.svg";